import axios from "axios";
import { apiKey } from "../config/config";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import DatePicker from "react-date-picker";
import DatePicker from "react-multi-date-picker";
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_ar";

export default function AddLightGuarantor({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [customerList, setCustomerList] = useState([]);
  const [customer, setCustomer] = useState();
  const [fullName, setFullName] = useState();
  const [releaseDate, setReleaseDate] = useState();
  const [source, setSource] = useState();
  const [idNum, setIdNum] = useState();
  const [DoB, setDoB] = useState();
  const [mobileNum, setMobileNum] = useState();
  const country = lang.Saudi_Arabia;
  const [branchId, setBranchId] = useState();
  const [selectedCalendar, setSelectedCalendar] = useState("arabic");

  const { id } = useParams();
  const isEditMode = Boolean(id);
  const navigate = useNavigate();

  const handleCalendarChange = (calendarType) => {
    setSelectedCalendar(calendarType);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSubmit = () => {
    try {
      const payload = {
        customer_id: customer,
        FullName: fullName,
        Valid_id: idNum,
        release_date: releaseDate,
        source: source,
        phone_no: mobileNum,
        DoB: DoB,
        country: country,
        branch_id: branchId,
      };

      const apiCall = isEditMode
        ? axios.put(`${apiKey}/update-guarantor/${id}`, payload, {
            headers: { Authorization: `Bearer ${token}` },
          })
        : axios.post(`${apiKey}/create-guarantor`, payload, {
            headers: { Authorization: `Bearer ${token}` },
          });

      apiCall
        .then((res) => {
          if (res.status === 200) {
            setFullName("");
            setIdNum("");
            setMobileNum("");
            setDoB("");
            navigate(-1);
            toast.success(res.data.Message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            console.log("error occured while uploading");
            toast.error(res.data.Error, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error("Error Occured", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (branchId) {
      try {
        axios
          .get(`${apiKey}/get-user/customer`, {
            params: {
              status: 1,
              branch_id: branchId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setCustomerList(res.data.result);
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (err) {
        console.error(err);
      }
    }
  }, [branchId, token]);

  useEffect(() => {
    if (isEditMode) {
      axios
        .get(`${apiKey}/get-guarantor/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data.result && res.data.result.length > 0) {
            const data = res.data.result[0];
            setCustomer(data.customer_id);
            setFullName(data.FullName);
            setIdNum(data.ValidNationalID);
            setMobileNum(data.MobilePhoneNo);
            setDoB(data.DoB);
            setReleaseDate(data.ReleaseDate ? new Date(data.ReleaseDate) : null);
            setSource(data.Source);
          }
        })
        .catch((err) => console.error("Error fetching guarantor", err));
    }
  }, [isEditMode, id, token]);

  useEffect(() => {
    setBranchId(
      JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id
    );
  }, []);
  return (
    <div>
      <main id="main" className="main">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="pagetitle">
          <h1>{lang.Customer_Management || "Customer Management"}t</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item active">
                {lang.Customer_Management || "Customer Management"}
              </li>
              <li className="breadcrumb-item">
                {isEditMode ? lang.Edit_Guarantor || "Edit Guarantor" : lang.Add_New_Guarantor || "Add New Guarantor"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex mt-3 mb-3">
                    <h4 className="headingh4 fw-bold">
                      {isEditMode ? lang.Edit_Guarantor || "Edit Guarantor" : lang.Add_New_Guarantor || "Add Guarantor"}
                    </h4>
                  </div>

                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    <div className="d-flex flex-column-reverse flex-lg-row mt-3 mb-3 justify-content-end">
                      <label className="select-calendar mt-3 mt-lg-0">
                        <span style={{ fontSize: "14px" }}>
                          {lang.select_calendar || "Select Calendar"}:
                        </span>
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="arabicRadio"
                            value="arabic"
                            checked={selectedCalendar === "arabic"}
                            onChange={() => handleCalendarChange("arabic")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="arabicRadio"
                          >
                            {lang.arabic || "Arabic"}
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="gregorianRadio"
                            value="gregorian"
                            checked={selectedCalendar === "gregorian"}
                            onChange={() => handleCalendarChange("gregorian")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="gregorianRadio"
                          >
                            {lang.gregorian || "Gregorian"}
                          </label>
                        </div>
                      </label>
                      <div className="d-flex justify-content-end">
                        <button
                          className="btn-save"
                          type="button"
                          onClick={handleCancel}
                        >
                          {lang.Cancel || "Cancel"}
                        </button>
                        <button type="submit" className="btn-cancel ms-4">
                          {lang.Save_And_Publish || "Save & Publish"}
                        </button>
                      </div>
                    </div>
                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="col-lg-8">
                        <label htmlFor="" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Select_Customer || "Select Customer"}:
                          </span>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            onChange={(e) => setCustomer(e.target.value)}
                            value={customer}
                            required
                          >
                            <option selected disabled></option>
                            {customerList.map((customer) => (
                              <option key={customer.id} value={customer.id}>
                                {customer.FullName}
                              </option>
                            ))}
                          </select>
                        </label>
                      </div>
                    </div>

                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="col-lg-4">
                        <label htmlFor="" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Full_Name || "Full Name"}:
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            required
                          />
                        </label>
                      </div>
                      <div className="col-lg-4">
                        <label htmlFor="" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Valid_Identity_Number ||
                              "Valid Identity Number"}
                            :
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            value={idNum}
                            onChange={(e) => setIdNum(e.target.value)}
                            required
                          />
                        </label>
                      </div>
                    </div>

                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="col-lg-4">
                        <label htmlFor="" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Release_Date || "Release Date"}:
                          </span>
                          <DatePicker
                            className="form-control w-100"
                            containerStyle={{
                              width: "100%",
                              height: "100%",
                            }}
                            style={{
                              width: "100%",
                              height: "100%",
                              margin: "0",
                            }}
                            calendar={
                              selectedCalendar === "arabic" ? arabic : ""
                            }
                            locale={
                              selectedCalendar === "arabic" ? arabic_ar : ""
                            }
                            value={releaseDate}
                            onChange={(e) => {
                              const dateObject = new Date(e);
                              setReleaseDate(dateObject);
                            }}
                          />
                        </label>
                      </div>
                      <div className="col-lg-4">
                        <label htmlFor="" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Source || "Source"}:
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            value={source}
                            onChange={(e) => setSource(e.target.value)}
                            required
                          />
                        </label>
                      </div>
                    </div>

                    <div className="row mb-3 d-flex justify-content-center">
                      <div className="col-lg-4">
                        <label htmlFor="" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Date_Of_Birth || "Date of Birth"}:
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            value={DoB}
                            onChange={(e) => setDoB(e.target.value)}
                            required
                          />
                        </label>
                      </div>
                      <div className="col-lg-4">
                        <label htmlFor="" className="w-100">
                          <span style={{ fontSize: "14px" }}>
                            {lang.Mobile_Number || "Mobile Number"}:
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            value={mobileNum}
                            onChange={(e) => setMobileNum(e.target.value)}
                            required
                          />
                        </label>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
